import React, { useState } from "react";
import {
  Card,
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
  Link,
  useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import { tokens } from "../../../theme";
import { useCrbMonthlyReport } from "./useCrbMonthlyReport";

const CrbMonthlyReportCard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { status, downloadUrl, error, requestReport } = useCrbMonthlyReport();

  const [startDate, setStartDate] = useState(
    dayjs().subtract(1, "month").startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    dayjs().subtract(1, "month").endOf("month").format("YYYY-MM-DD")
  );

  const isBusy = status === "Pending" || status === "Running";

  return (
    <Card
      sx={{
        padding: "16px",
        marginTop: "16px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        background: `${colors.primary[400]} !important`,
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
        CRB Monthly Report
      </Typography>

      <Box display="flex" gap={2} flexWrap="wrap" alignItems="center">
        <TextField
          label="Start Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          disabled={isBusy}
        />
        <TextField
          label="End Date"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          disabled={isBusy}
        />
        <Button
          variant="contained"
          color="primary"
          disabled={isBusy}
          onClick={() => requestReport(startDate, endDate, null)}
        >
          {isBusy ? "Request Pending" : "Request Report"}
        </Button>
        {isBusy && <CircularProgress size={24} />}
      </Box>

      {status !== "Idle" && (
        <Typography variant="body2" sx={{ marginTop: 2 }}>
          Status: {status}
        </Typography>
      )}

      {(status === "Pending" || status === "Running" || status === "Completed") && (
        <Typography variant="body2" sx={{ marginTop: 1 }}>
          We'll also email the report to you once it's ready — check your inbox.
        </Typography>
      )}

      {status === "Completed" && downloadUrl && (
        <Box sx={{ marginTop: 1 }}>
          <Link href={downloadUrl} target="_blank" rel="noopener noreferrer">
            Download report
          </Link>
        </Box>
      )}

      {status === "Failed" && (
        <Typography variant="body2" color="error" sx={{ marginTop: 1 }}>
          The report failed to generate. Please try again.
        </Typography>
      )}

      {error && (
        <Typography variant="body2" color="error" sx={{ marginTop: 1 }}>
          {typeof error === "string" ? error : JSON.stringify(error)}
        </Typography>
      )}
    </Card>
  );
};

export default CrbMonthlyReportCard;
